
window.theme = window.theme || {};

theme.sliders = (function(){
  function init_counters(event){
    $(event.target).parent().find('.carousel-pagination .count').text(`${event.item.index + event.page.size}/${event.item.count}`)
    $(event.target).parent().find('.carousel-pagination .indicator span').css('max-width', `${(100 / event.item.count) * (event.item.index + event.page.size)}%`)
  }
  function update_counters(event){
    init_counters(event)
  }
  function init_nav(event){
    let elem = event.item.index + event.page.size
    let hash = $($(event.target).find('[data-hash]')[0]).data('hash')
    hash = hash.split('-')
    hash.pop()
    hash = hash.join('-')
    $(event.target).parent().parent().find('.owl-navigation a').removeClass('active')
    $(event.target).parent().parent().find(`.owl-navigation a[href="#${hash}-${elem}"]`).addClass('active')
  }
  function update_nav(event){
    init_nav(event)
  }
  function init_headings(event) { 
    $('.headings p').removeClass('active')
    $(`[data-heading="${$(event.target).find('.active').children().data('active')}"]`).addClass('active')
  }
  function update_headings(event) { 
    init_headings(event)
  }
  function init_round(event) {
    $('.round-indicator-container .c100').attr('class', 'round-indicator c100')
    $('.round-indicator-container .c100').addClass(`p${(100 / event.item.count) * (event.item.index + event.page.size)}`)
  }
  function update_round(event) {
    init_round(event)
  }

  function init(){
    $('.design-carousel').owlCarousel({
      thumbs: true,
      thumbImage: false,
      thumbsPrerendered: true,
      items: 1,
      dots: false,
      nav: false,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      autoplay: true,
      onInitialized: init_counters,
      onTranslate: update_counters
    })
    
    $('.indicated-slider').owlCarousel({
      items: 1,
      dots: false,
      nav: false,
      onInitialized: function(event){
        init_round(event)
        $('.round-indicator-container').click(function(){
          $(event.target).trigger('next.owl.carousel')
        })
      },
      onTranslate: update_round
    })
    $('.bottom-slider').owlCarousel({
      items: 1,
      dots: false,
      nav: true,
      loop: false,
      margin: 50,
      responsive:{
          992:{
              items:3
          }
      },
    })
    $('.quotes-carousel').owlCarousel({
      items: 1,
      dots: true,
      nav: false,
      autoplay: true,
      loop: false,
      rewind: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      touchDrag: false,
      mouseDrag: false
    })

    $('.images-carousel').owlCarousel({
      items: 1,
      dots: false,
      nav: false,
      loop: false,
      rewind: true,
      autoplay: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      thumbs: true,
      thumbsPrerendered: true
    })
    $('.better-carousel').owlCarousel({
      items: 1,
      dots: false,
      nav: false,
      loop: false,
      rewind: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      URLhashListener:true,
      onInitialized: init_nav,
      onTranslate: update_nav
    })
    $('.news-carousel').owlCarousel({
      items: 1,
      dots: false,
      nav: false,
      loop: false,
      rewind: true,
      autoplay: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      URLhashListener:true,
      onInitialized: init_nav,
      onTranslate: update_nav,
      autoplayTimeout: 3000
    })

    $('.left-carousel').owlCarousel({
      items: 1,
      dots: false,
      nav: false,
      onInitialized: function(event){
        init_nav(event)
        init_counters(event)
      },
      onTranslate: function(event){
      	update_counters(event)
      	update_nav(event)
      },
      URLhashListener:true
    })
    $('.right-carousel').owlCarousel({
      items: 1,
      dots: true,
      nav: false,
      autoplay: true,
      loop: false,
      rewind: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      touchDrag: false,
      mouseDrag: false
    })
    $('.healthcare-carousel').owlCarousel({
      items: 1,
      dots: true,
      nav: false,
      onInitialized: init_nav,
      onTranslate: update_nav,
      URLhashListener:true,
      touchDrag: false,
      mouseDrag: false,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn'
    })
    $('.video-carousel').owlCarousel({
      items:1,
      merge:false,
      loop: false,
      rewind: true,
      margin:150,
      video:true,
      startPosition: 1,
      lazyLoad:false,
      nav: true,
      center:true,
      responsive:{
          480:{
              items:2
          },
          600:{
              items:2
          }
      },
      onTranslate: function() {
        $('.video-carousel .owl-item.center iframe').remove()
      }
    })
    $('.testimonials-carousel').owlCarousel({
      items: 1,
      dots: false,
      margin: 50,
      onInitialized: init_counters,
      onTranslate: update_counters,
      responsive:{
          993:{
              items: 5
          }
      },
    })
  }

  return {
    init: init
  }
})($)

theme.cart = (function(){
  var sidebar
  var resizeTimer
  $(window).on('resize', function(e) {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(function() {
        if ($(window).width() <= 992){
          if (sidebar._opened == true){
            sidebar.close()
          }
          if (typeof sidebar == "function") {
            sidebar.destroy()
          }
          sidebar = new Slideout({
            'panel': document.getElementById('content'),
            'menu': document.getElementById('ajax-cart'),
            'padding': 320,
            'tolerance': 70,
            'easing': 'ease',
            'side': 'right'
          })
        } else if ($(window).width() > 992) {
          if (sidebar._opened == true){
            sidebar.close()
          }
          if (typeof sidebar == "function") {
            sidebar.destroy()
          }
          sidebar = new Slideout({
            'panel': document.getElementById('content'),
            'menu': document.getElementById('ajax-cart'),
            'padding': 449,
            'tolerance': 70,
            'easing': 'ease',
            'side': 'right'
          })
        }
              
    }, 250)
  
  })
  if ($(window).width() <= 992){
    sidebar = new Slideout({
      'panel': document.getElementById('content'),
      'menu': document.getElementById('ajax-cart'),
      'padding': 320,
      'tolerance': 70,
      'easing': 'ease',
      'side': 'right'
    })
  } else {
    sidebar = new Slideout({
      'panel': document.getElementById('content'),
      'menu': document.getElementById('ajax-cart'),
      'padding': 449,
      'tolerance': 70,
      'easing': 'ease',
      'side': 'right'
    })
  }
  function reloadCart(){
    $('#ajax-cart .cart-body .ajax-container').load('/cart?view=ajax', function(){
        $('.cart-body .ajax-container .fade-me-in').fadeIn()
        bindCartEvents()
        let jsonCart = JSON.parse($('#cartJSON').text())
        $('.cart-count').text(jsonCart.item_count)
      })
  }
  function addToCart_form($form, buy_btn){
    $.ajax({
      url: '/cart/add.js', 
      type: 'POST',
      data: $form.serialize(),
      dataType : "json",
      contentType: "application/x-www-form-urlencoded",
      success: function(){
          $('#ajax-cart .cart-body .ajax-container').fadeOut().html(`
          <div class="loader">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>`).fadeIn()

          if (buy_btn !== "btnbuy") {
            sidebar.open()
            nativeToast({
              message: 'Succesfully added',
              timeout: 5000,
              rounded: true,
              position: 'south',
              closeOnClick: true,
              type: 'success'
            })
          }

          if( window.Extend && window.ExtendShopify ) {
              var extendOfferId = '#extend-offer'
              var quantityElement = document.querySelector('input[name="quantity"]')
              var quantity = quantityElement && quantityElement.value
              
              ExtendShopify.handleAddToCart(
                extendOfferId, 
                { 
                  quantity: quantity,
                  modal: true,
                  done: function() {

                    if($form.data('subscriber') == true){
                      $('#subscription-content button').click(function(){
                        let variantId = $(this).data('variant')
                        $.ajax({
                          url: '/cart/add.js',
                          type: 'POST',
                          data: JSON.stringify({ quantity: 1, id: variantId, properties: {
                              shipping_interval_frequency: 12,
                              shipping_interval_unit_type: "Month"
                            } 
                          }),
                          dataType: "json",
                          contentType: "application/json",
                          success: function () {
                            theme.cart.reloadCart()
                            $.fancybox.close();
                          },
                          error: function (e) {
                              let error = JSON.parse(e.responseText)
                              console.log(error)
                              if (error.status == 422) {
                                  nativeToast({
                                      message: 'Out Of Stock!',
                                      timeout: 5000,
                                      rounded: true,
                                      position: 'south',
                                      closeOnClick: true,
                                      type: 'error'
                                  })
                              }
                          }
                      })
                      })
                      $.fancybox.open({
                        src  : '#subscription-content',
                        type : 'inline',
                      });
                    }
                    
                    // After Extend Popup redirect
                    if (buy_btn == "btnbuy") {
                      location.href='/checkout';
                    }else{
                      theme.cart.reloadCart()
                    }
                  } 
                }
              ) 
          } else {
            if (frm_buy_btn == "btnbuy") {
              location.href='/checkout';
            }
            if($form.data('subscriber') == true){
              $('#subscription-content button').click(function(){
                let variantId = $(this).data('variant')
                $.ajax({
                  url: '/cart/add.js',
                  type: 'POST',
                  data: JSON.stringify({ quantity: 1, id: variantId, properties: {
                      shipping_interval_frequency: 12,
                      shipping_interval_unit_type: "Month"
                    } 
                  }),
                  dataType: "json",
                  contentType: "application/json",
                  success: function () {
                    theme.cart.reloadCart()
                    $.fancybox.close();
                  },
                  error: function (e) {
                      let error = JSON.parse(e.responseText)
                      console.log(error)
                      if (error.status == 422) {
                          nativeToast({
                              message: 'Out Of Stock!',
                              timeout: 5000,
                              rounded: true,
                              position: 'south',
                              closeOnClick: true,
                              type: 'error'
                          })
                      }
                  }
              })
              })
              $.fancybox.open({
                src  : '#subscription-content',
                type : 'inline',
              });
            }
          }

      },
      error: function(e){
        console.log(e)
        let error = JSON.parse(e.responseText)
        if (error.status == 422){
          nativeToast({
            message: 'No more items available!',
            timeout: 5000,
            rounded: true,
            position: 'south',
            closeOnClick: true,
            type: 'error'
          })
        }
      }
    })
  }
  function addToCart(variant_id, quantity){
    $.ajax({
      url: '/cart/add.js', 
      type: 'POST',
      data: JSON.stringify({ quantity: quantity, id: variant_id }),
      dataType : "json",
      contentType: "application/json",
      success: function(){
          $('#ajax-cart .cart-body .ajax-container').fadeOut().html(`
          <div class="loader">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>`).fadeIn()
          sidebar.open()
          nativeToast({
            message: 'Succesfully added',
            timeout: 5000,
            rounded: true,
            position: 'south',
            closeOnClick: true,
            type: 'success'
          })
      },
      error: function(e){
        let error = JSON.parse(e.responseText)
        if (error.status == 422){
          nativeToast({
            message: 'No more items available!',
            timeout: 5000,
            rounded: true,
            position: 'south',
            closeOnClick: true,
            type: 'error'
          })
        }
      }
    })
  }
  function updateQuantity(quantity, key){
    $.ajax({
      url: '/cart/change.js', 
      type: 'POST',
      data: JSON.stringify({ quantity: quantity, id: key }),
      dataType : "json",
      contentType: "application/json",
      success: function(data){
        if (quantity > 0){
          let item_quantity = data.items.filter(i=>i.key == key)[0].quantity
          if (quantity != item_quantity) {
            nativeToast({
              message: 'No more items available!',
              timeout: 5000,
              rounded: true,
              position: 'south',
              closeOnClick: true,
              type: 'error'
            })
            $(`[data-key="${key}"]`).val(item_quantity)
          } else {
            nativeToast({
              message: 'Quanity changed',
              timeout: 5000,
              rounded: true,
              position: 'south',
              closeOnClick: true,
              type: 'success'
            })
            reloadCart()
          }
        } else {
          nativeToast({
            message: 'Item Removed',
            timeout: 5000,
            rounded: true,
            position: 'south',
            closeOnClick: true,
            type: 'success'
          })
          reloadCart()
        }
      },
      error: function(e){
        let error = JSON.parse(e.responseText)
        if (error.status == 422){
          nativeToast({
            message: 'No more items available!',
            timeout: 5000,
            rounded: true,
            position: 'south',
            closeOnClick: true,
            type: 'error'
          })
        }
      }
    })
  }

  function bindCartEvents(){
    $('.quantity_group span.plus').click(function () {
      if ($(this).prev().val() < $(this).prev().attr('max')) $(this).prev().val(+$(this).prev().val() + 1).change()
    })
  
    $('.quantity_group span.minus').click(function () {
          if ($(this).next().val() > 0) $(this).next().val(+$(this).next().val() - 1).change()
    })
    $('#ajax-cart .cart-body .ajax-container input.quantity').change(function(){
       updateQuantity(Number($(this).val()), $(this).data('key'))
    })
  }
  function init(){
      // Random Stars
      var generateStars = function(){
          
        var $galaxy = $(".galaxy");
        var iterator = 0;
        
        while (iterator <= 300){
            var xposition = Math.random();
            var yposition = Math.random();
            var star_type = Math.floor((Math.random() * 10) + 1);
            var position = {
                "x" : $galaxy.width() * xposition,
                "y" : $galaxy.height() * yposition,
            };
            
            $('<div class="star star-type' + star_type + '"></div>').appendTo($galaxy).css({
                "top" : position.y,
                "left" : position.x
            });
            
            iterator ++;
        }
        
      };

      // generateStars();
    $('a[href="#cart"]').click(function(e){
        e.preventDefault()
        sidebar.toggle()
    })
    $('#dismiss').click(function(e){
        e.preventDefault()
        sidebar.close()
    })
    sidebar.on('beforeopen', function(){
        $('#ajax-cart .cart-body .ajax-container').html(`<div class="loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>`)
    })
    sidebar.on('open', function() {
        reloadCart()
    })
    bindCartEvents()
    if (window.location.href.indexOf('oc=true') > 0){
        sidebar.open()
    }
    $('a[href="#toggle-menu"]').click(function(){
      $('.mobile-overlay').toggleClass('active')
    })
    $('.mobile-overlay span.close').click(function(){
      $('.mobile-overlay').toggleClass('active')
    })

    $('form[action="/cart/add"]').submit(function(e){
      e.preventDefault()
      addToCart_form($(this))
    })

    // Generate Recommended Products --------------------------------------------

    var body = document.querySelector('body');
    if (body.classList.contains('product')) {

          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
      
            observer.unobserve(productRecommendationsSection);
      
            const url = productRecommendationsSection.dataset.url;
      
            fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');
      
                if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;
                }
      
                let add_btn = document.querySelectorAll('.btn-add');
                add_btn.forEach(elem => {
                  let variant_id = elem.getAttribute('data-product-variant');
                  elem.onclick = e => { 
                    addToCart(variant_id, 1);
                  };
                });
            })
            .catch(e => {
                console.error(e);
            });
          };
          const productRecommendationsSection = document.querySelector('.product-recommendations');
          const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
          observer.observe(productRecommendationsSection);
    }

    // Add To Cart (Collection Page) --------------------------------------------
    
    let add_btn = document.querySelectorAll('.btn-add');
    add_btn.forEach(elem => {
      let variant_id = elem.getAttribute('data-product-variant');
      elem.onclick = e => { 
        addToCart(variant_id, 1);
      };
    });
    
    // Trigger Checkout on Product Page --------------------------------------------

    if (body.classList.contains('product')) {
      //Select form --------------
      // let form = document.querySelector('form[action="/cart/add"]');
      //Onclick Buynow -----------
      let btnBuy = document.querySelector('#buyNow');
      btnBuy.onclick = e => {
        let form = $('form[action="/cart/add"]');
        addToCart_form(form,'btnbuy');
      }
    }


    
    
  }
  return {
    sidebar: sidebar,
    addToCart: addToCart,
    reloadCart: reloadCart,
    addToCart_form: addToCart_form,
    init: init
  }
})($)

theme.contact = (function(){
  function init(){
    if($('body').hasClass('contact')){
      $(document).on('click','.form .close', function(e){
        e.preventDefault()
        $('.form').fadeOut()
      })

      $(document).on('click','a[href="#not-anchor-openform"]', function(e){
        e.preventDefault()
        $('.form').fadeIn()
        $("html, body").animate({ scrollTop: 0 })
      })

      $(document).on('click','.form .close', function(e){
        e.preventDefault()
        $('.form').fadeOut()
      })
      if(window.location.href.includes('contact_posted=true') || window.location.href.includes('form_type=contact')){
        $('.form').fadeIn()
      }
    }
  }
  return {
    init: init
  }
})($)

theme.additional_scripts = (function(){
  function init(){
    $('.video-popup').magnificPopup({
      type: 'iframe',
      patterns: {
        youtube: {
          src: '//www.youtube.com/embed/%id%?autoplay=1&modestbranding=1&color=white&iv_load_policy=3'
        }
      }
    })
    $('a[href^="#"]').not('a[href^="#owl-"]').not('a[href^="#not-anchor"]').click(function(event){
      event.preventDefault();
      let top = $(this).offset()
      $('html, body').animate({
          scrollTop: top.top
      }, 500);
    })

    $('a[href^="#owl-better-"]').click(function(){
      if($(window).width() <= 1199){
        let better = $('#better').offset()
        $('html, body').animate({
            scrollTop: better.top
        }, 500);
      }
    })
    $('[data-load-more]').click(async function(e){
      e.preventDefault()
      let url = $(this).attr('href')
      let data = await $.ajax(url)
      if ($(data).find('[data-load-more]').length > 0){
        $(this).attr('href', $(data).find('[data-load-more]').attr('href'))
      } else {
        $(this).remove()
      }

      $('[data-load-here]').append($(data).find('[data-load-here]').html())
    })
  }

  return {
    init: init
  }
})($)

theme.init = function(){
  theme.cart.init()
  theme.sliders.init() 
  theme.contact.init()
  theme.additional_scripts.init()
  AOS.init()
}

$(function(){
  theme.init($)
})